/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */
import _ from 'lodash';

// ── Card title derivation ──────────────────────────────────────────
// Pure helpers, shared by the full and compact catalogue card layouts.
// This is the logic previously inlined in CatalogueProductCard.getImportedDisplayName.

// The imported workspace type name to show for a product: the last entry for the product
// in the (name-sorted) env types list — same selection the card makes today.
function getImportedDisplayName(product, envTypesStore) {
  if (!envTypesStore) return undefined;
  const prefix = `${_.get(product, 'productId')}-`;
  const forProduct = _.filter(_.get(envTypesStore, 'list', []), et => _.startsWith(_.get(et, 'id'), prefix));
  if (_.isEmpty(forProduct)) return undefined;
  return _.last(forProduct).name || undefined;
}

// { title, secondaryName } — secondaryName is set only when an imported name exists and
// differs from the SC product name (Requirements 2.3, 2.4).
function getCardTitleParts(product, envTypesStore) {
  const productName = _.get(product, 'productName', '');
  const importedName = getImportedDisplayName(product, envTypesStore);
  if (!importedName || importedName === productName) return { title: productName, secondaryName: undefined };
  return { title: importedName, secondaryName: productName };
}

export { getImportedDisplayName, getCardTitleParts };
